import Minus from "../../src/assets/icons/Minus.png";
import FlowOfPlay from "../../src/assets/icons/FlowOfPlay.png";
import ThreatMap from "../../src/assets/icons/ThreatMap.png";
import AreasOfControl from "../../src/assets/icons/AreasOfControl.png";
import SystemFit from "../../src/assets/icons/Systemfit.png";
import OptimalPathways from "../../src/assets/icons/OptimalPathways.png";
import PassingNet from "../../src/assets/icons/PassingNet.png";
import PassingAttack from "../../src/assets/icons/PassingAttack.png";
import Pitch3D from '../../src/assets/icons/Pitch3D.png';
import Pitch2D from '../../src/assets/icons/Pitch2D.png';
import styled from 'styled-components';

const getColor = (isSelected: boolean, theme: any) => isSelected ? 'var(--Brand-black-500, #111)' : theme.playerColor;
const getIconColor = (isSelected: boolean, theme: any) => isSelected ? 'var(--Brand-black-500, #111)' : theme.playerColor;
const getIconFilter = (isSelected: boolean, theme: any) => isSelected ? 'none' : theme.playerColor === 'var(--Brand-white-500, #FFF)' ? 'grayscale(100%) brightness(0) invert(1)' : 'none'
const getBackground = (isSelected: boolean, theme: any) => isSelected ? 'var(--Brand-green-1-500, #00D1A8)' : theme.secondaryButtonBackground;

export const PitchSidebar = styled.div<{isHovered : boolean}>`
  border: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
  border-radius: 5px;
  border-top-left-radius: ${({ isHovered }) => isHovered ? `0px` : `5px`};
  border-bottom-right-radius: ${({ isHovered }) => isHovered ? `0px` : `5px`};
  & .sidebar-btn-parent:first-of-type > button {
    border-top-left-radius:  ${({ isHovered }) => isHovered ? `0px` : `5px`};
    border-top-right-radius:  ${({ isHovered }) => isHovered ? `0px` : `5px`};
  }
  & .sidebar-btn-parent:last-of-type > button {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: ${({ isHovered }) => isHovered ? `0px` : `5px`};
  }
  & .sidebar-btn-parent:last-of-type  > .vis-name {
    height: 101%;
    margin-bottom: -2px;
    border-bottom: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
    border-bottom-right-radius: 5px;
  }
  & p {
    display: flex;
    align-items: center;
    border: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
    border-radius: 4px 4px 0px 0px;
    border-bottom: 0;
    width: 227px;
    position: absolute;
    margin-top: -40px;
    margin-left: -1px;
    padding: 0px 15px;
    height: 40px;
    box-sizing: border-box;
    font-size: 500;
    font-family: "DM Mono";
    background: ${({ theme }) => theme.secondaryButtonBackground};
    z-index: 2;
  }
`;

const StyledPWBtn = styled.button<{isSelected : boolean}>`
  padding: 8px 12px;
  height: fit-content;
  border: 0;
  color:${({ isSelected, theme }) => getColor(isSelected || false, theme)};
  background: ${({ isSelected, theme }) => getBackground(isSelected || false, theme)};
  & img {
    color:${({ isSelected, theme }) => getIconColor(isSelected || false, theme)};
    filter: ${({ isSelected, theme }) => getIconFilter(isSelected || false, theme)};
    height: 24px;
    width: 24px;
    margin-bottom: -3px;
  }
`;

const iconMap: { [key: string]: JSX.Element } = {
  minus: <img src={Minus} alt="minusIcon" />,
  flowofplay: <img src={FlowOfPlay} alt="flowOfPlayIcon" />,
  threatmap: <img src={ThreatMap} alt="threatMapIcon" />,
  systemfit: <img src={SystemFit} alt="systemFitIcon" />,
  passingnetwork: <img src={PassingNet} alt="passingNetworkIcon" />,
  optimalpathways: <img src={OptimalPathways} alt="optimalPathwaysIcon" />,
  passingattack: <img src={PassingAttack} alt="optimalPathwaysIcon" />,
  areasofcontrol: <img src={AreasOfControl} alt="areasOfControlIcon" />,
  pitch2d: <img src={Pitch2D} alt='pitch2DIcon' />,
  pitch3d: <img src={Pitch3D} alt='pitch3DIcon' />
};

interface PWSidebarBtnsProps {
  iconType: string;
  isSelected: boolean;
  className?: string;
}

export const PWSidebarBtns : React.FC<PWSidebarBtnsProps> = ({iconType, isSelected, className}) => {
  const icon = iconType ? iconMap[iconType.toLowerCase()] : null;
  return (
    <StyledPWBtn isSelected={isSelected} className={className}>
      {icon}
    </StyledPWBtn>
  )

}